export default function LoadingSpinner({open}) {
    if (!open) {
        return null;
    }

    return (
        <div className="spinner-container">
            <div className="loading-spinner">
            </div>
        </div>
    );
}
